import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomButton from '../../../views/shared/CustomButton';
import VimeoSearchBar from './VimeoSearchBar';
import { VimeoVideoGrid } from './VimeoVideoGrid';
import VimeoVideoPreview from './VimeoVideoPreview';
import { useVimeoSearch } from '../hooks/useVimeoSearch';

const useStyles = makeStyles({
  content: {
    height: 500,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  leftCol: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '16px 8px 16px 16px',
    borderRight: '1px solid #E4E7EC',
  },
  rightCol: {
    height: '100%',
    padding: '16px 16px 16px 8px',
    display: 'flex',
    alignItems: 'flex-start',
  },
  searchBar: {
    marginBottom: 12,
  },
});

function VimeoPickerModal({ open, onClose, onSelect }) {
  const classes = useStyles();
  const [query, setQuery] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    if (open) {
      setQuery('');
      setSelectedVideo(null);
    }
  }, [open]);

  const { results, isLoading, error, isRateLimited, msUntilReset } = useVimeoSearch(query);

  const handleSelect = () => {
    onSelect(selectedVideo.videoUrl);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle style={{ fontSize: '20px' }}>Select a Vimeo Video</DialogTitle>
      <DialogContent classes={{ root: classes.content }}>
        <Grid container style={{ flex: 1, height: '100%' }}>
          <Grid item xs={7} className={classes.leftCol}>
            <div className={classes.searchBar}>
              <VimeoSearchBar
                query={query}
                onChange={setQuery}
                isLoading={isLoading}
                isRateLimited={isRateLimited}
                msUntilReset={msUntilReset}
              />
            </div>
            <VimeoVideoGrid
              results={results}
              isLoading={isLoading}
              error={error}
              selectedVideo={selectedVideo}
              onSelect={setSelectedVideo}
            />
          </Grid>
          <Grid item xs={5} className={classes.rightCol}>
            <VimeoVideoPreview video={selectedVideo} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CustomButton label="Cancel" variant="contained" type="secondary" onClick={onClose} />
        <CustomButton label="Select Video" variant="contained" type="primary" disabled={selectedVideo === null} onClick={handleSelect} />
      </DialogActions>
    </Dialog>
  );
}

export default VimeoPickerModal;
